module.exports = __webpack_public_path__ + "static/media/home-content-bg.7f0cf085.svg";